<!-- 
difference between RadioImageBase and RadioBase
  1. Replaced v-radio with v-card
  2. added getValue() click event to v-card
  3. getValue() targets the buttons text and assigns to the question.Value
  4. the styles used here should ONLY be used for this component
 -->
<template>
  <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 pa-0">
    <HomeBaseLabel :question="question" />
    <v-radio-group
      row
      :hide-details="
        question.HideDetails != null ? question.HideDetails : 'auto'
      "
      class="mt-n1 mr-n8 radioImage iconImage overflow-x-auto"
      :data-uiid="question.DataUiid"
      v-model="question.Value"
      :rules="getRules"
    >
      <v-card
        :ripple="false"
        class="elevation-0 mt-2 mr-2"
        :class="{
          'radioImage--active': question.Value === option.Value,
        }"
        :data-uiid="option.DataUiid"
        v-for="(option, index) in question.Options"
        :key="index"
        @click="getValue(option.Value)"
      >
        <div class="radioImage__outer">
          <div class="radioImage__inner">
            <v-img
              :src="require(`@/assets/icons/${option.Image.Path}`)"
              :width="option.Image.MaxWidth"
              :height="option.Image.MaxHeight"
              :alt="option.Image.ImageName"
            ></v-img>
            <label
              class="font-weight-bold label-color mt-3"
              v-html="option.Text"
            ></label>
          </div>
        </div>
      </v-card>
    </v-radio-group>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "RadioImageBase",
  components: {
    HomeBaseLabel,
  },
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getValue(value) {
      this.question.Value = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-color {
  color: $black-2 !important;
}
</style>
